// A redirect is safe only after the endpoint explicitly confirms session destruction.
export async function confirmedAdminLogout(fetcher = fetch, timeoutMs = 15000) {
  const controller = new AbortController();
  let timer;
  const deadline = new Promise((_, reject) => {
    timer = setTimeout(() => {
      reject(new Error('Sign-out could not be confirmed. Please try again.'));
      controller.abort();
    }, timeoutMs);
  });
  const request = async () => {
    const response = await fetcher('/api/v1/admin/auth/logout', {
      method: 'POST', credentials: 'include', signal: controller.signal,
    });
    if (!response.ok) throw new Error('Sign-out could not be confirmed. Please try again.');
    const body = await response.json();
    if (body?.outcome !== 'success') throw new Error('Sign-out could not be confirmed. Please try again.');
  };
  try { await Promise.race([request(), deadline]); }
  finally { clearTimeout(timer); }
}
